export const gettersTypes = {
  emptyMeetingsFilters: '[meeting] empty meetings filters',
  dirtyMeetingsFilters: '[meeting] dirty meetings filters',
};

const getters = {
  [gettersTypes.emptyMeetingsFilters]: (state) => {
    return Object.values(state.meetingsFilters).every((f) => !f || !f.length);
  },
  [gettersTypes.dirtyMeetingsFilters]: (state) => {
    return Object.values(state.meetingsFilters).some((f) => !!f && f.length);
  },
};

export default getters;
